<template>
    <div id="app">
        <router-view v-if="isRouterAlive"></router-view>
    </div>
</template>
<script>
import { removeKeyboardKey, addKeyboardKey, clearKeyboardKeys } from '../src/components/common/keyboard';
export default {
    name: 'app',
    provide() {
        //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
        return {
            reload: this.reload
        };
    },
    data() {
        return {
            isRouterAlive: true //控制视图是否显示的变量
        };
    },
    created() {
        // 添加监听
        window.addEventListener('blur', clearKeyboardKeys);
        window.addEventListener('keydown', addKeyboardKey);
        window.addEventListener('keyup', removeKeyboardKey);
        // 记住添加事件和卸载事件总是成对存在
        this.$once('hook:beforeDestroy', () => {
            window.removeEventListener('blur', clearKeyboardKeys);
            window.removeEventListener('keydown', addKeyboardKey);
            window.removeEventListener('keyup', removeKeyboardKey);
        });
    },
    methods: {
        reload() {
            this.isRouterAlive = false; //先关闭，
            this.$nextTick(function () {
                this.isRouterAlive = true; //再打开
            });
        }
    }
};
</script>
<style>
@import './assets/css/main.css';
/* @import "./assets/css/color-dark.css";深色主题 */
/* @import './assets/css/theme-green/color-green.css'; 浅绿色主题 */
@import './assets/css/color-white.css'; /*浅色主题*/
</style>